import React, { useState } from 'react'
import { Button, useTheme } from '@material-ui/core'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import PauseIcon from '@material-ui/icons/Pause'
import CheckIcon from '@material-ui/icons/Check'
import ReplayIcon from '@material-ui/icons/Replay'
import { Container } from '../../components'
import { vendorProjectApi } from '../../contexts'
import { VendorTask, getTaskTransitions } from '../../models'

interface Props {
    task: VendorTask
}

const COLOR_BY_KIND = {
    positive: '#2e7d32',
    neutral: '#1976d2',
    negative: '#d32f2f',
} as const

const ICON_BY_LABEL: Record<string, React.ReactNode> = {
    Start: <PlayArrowIcon style={{ fontSize: 16 }} />,
    Resume: <PlayArrowIcon style={{ fontSize: 16 }} />,
    Pause: <PauseIcon style={{ fontSize: 16 }} />,
    Complete: <CheckIcon style={{ fontSize: 16 }} />,
    Reset: <ReplayIcon style={{ fontSize: 16 }} />,
}

export const TaskTransitionButtons = ({ task }: Props) => {
    const theme = useTheme()
    const { transitionProjectTask } = vendorProjectApi()
    const [pendingStatus, setPendingStatus] = useState<string | null>(null)

    const transitions = getTaskTransitions(task)

    if (transitions.length === 0) return null

    return (
        <Container style={{ gap: theme.spacing(0.75), flexWrap: 'wrap' }}>
            {transitions.map((tr) => {
                const color = COLOR_BY_KIND[tr.kind]
                const isPending = pendingStatus === tr.toStatus
                return (
                    <Button
                        key={tr.toStatus}
                        size="small"
                        variant="outlined"
                        disabled={!!pendingStatus}
                        startIcon={ICON_BY_LABEL[tr.label]}
                        style={{
                            color,
                            borderColor: color,
                            fontWeight: 700,
                            opacity: isPending ? 0.6 : 1,
                            textTransform: 'none',
                            paddingTop: 2,
                            paddingBottom: 2,
                        }}
                        onClick={async () => {
                            setPendingStatus(tr.toStatus)
                            try {
                                await transitionProjectTask(
                                    task.id,
                                    tr.toStatus,
                                )
                            } finally {
                                setPendingStatus(null)
                            }
                        }}
                    >
                        {tr.label}
                    </Button>
                )
            })}
        </Container>
    )
}
